<template>
  <v-list>
    <v-list-item :key="action.Action_ID" v-for="action in sortedActions">
      <v-list-item-action>
        <v-icon color="success"> mdi-check-circle </v-icon>
      </v-list-item-action>
      <v-list-item-content class="ml-2">
          {{action.ActionNotes || emptyActionNote}}
      </v-list-item-content>
      <v-list-item-action>
        <v-list-item-action-text>Έγινε στις:</v-list-item-action-text>
        {{action.DateInsert | fullDate}}
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "IssueActionsList",
  props:{
    actions:Array,
    emptyActionNote:{type:String, default:true}
  },
  computed:{
    sortedActions(){
      return this.actions.slice().sort((a,b)=>{
        return new Date(b.DateInsert) - new Date(a.DateInsert)
      })
    }
  }
}
</script>

<style scoped>

</style>